export const ApplicationConstant = {
    ApplicationID : 14,
    clientId : 9,
    DEFAULT_DATE_FORMAT: 'DD/MM/Y'
};
